import React from 'react';
import { getOrdinalSuffix } from '@utils/helpers';
import { Badge } from './Badge';

export const CollectorBadge = ({ rank }: { rank: number }) => {
  const suffix = getOrdinalSuffix(rank);

  return (
    <div className="relative flex gap-2.5">
      <div
        className="flex aspect-square h-[62px] w-[62px] 
        rounded-full shadow-secondary backdrop-blur-2xl lg:h-[90px] lg:w-[90px]
        [&_svg]:h-[inherit] [&_svg]:w-[inherit]
        "
      >
        <Badge />
      </div>
      <div className="absolute flex h-[62px] w-[62px] items-center justify-center font-title font-medium lg:h-[90px] lg:w-[90px]">
        <div className="text-title-s lg:text-[24px]">{rank}</div>
        <div className="absolute right-2 top-5 text-[8px] lg:top-6 lg:text-base-s">{suffix}</div>
      </div>
    </div>
  );
};
